<script lang="ts" module>
  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';

  export interface PaginationProps {
    pages: number;
    current: number;
    onPageChange?: (page: number) => void;
    hideOnSinglePage?: boolean;
  }
</script>

<script lang="ts">
  let { pages = 1, current, hideOnSinglePage = true, onPageChange }: PaginationProps = $props();

  const selected = $derived(Math.max(Math.min(current, pages - 1), 0));

  function handleNext() {
    if (selected < pages - 1) {
      onPageChange?.(selected + 1);
    }
  }

  function handlePrev() {
    if (selected > 0) {
      onPageChange?.(selected - 1);
    }
  }
</script>

{#if pages > 1 || (!hideOnSinglePage && pages > 0)}
  <div class="flex w-fit items-center">
    <BaseBtn onclick={handlePrev}>
      <Icon icon="KeyboardArrowLeft" class="size-4"></Icon>
    </BaseBtn>
    <p class="font-sans text-xs font-normal text-c-base">{selected + 1}/{pages}</p>
    <BaseBtn onclick={handleNext}>
      <Icon icon="KeyboardArrowRight" class="size-4"></Icon>
    </BaseBtn>
  </div>
{/if}
